import React, { Component } from 'react';
import { connect } from 'react-redux';
import { safeDeepGet, safeDeepGetWithType } from 'iotera-base/json';
import { isEmpty } from 'iotera-base/object'
import { setDeviceTagCategory } from "../../../testActions";
import { store } from "../../../testStore";
import { withRouter } from 'react-router-dom';
import { S, domainIsTenant } from '../../../routes/routes';

import { buildWBoundActions, buildWSelector } from '../../../redux/ducks'
import { actions as notificationActions } from '../../../redux/ducks/notification'
import { actions as modalActions } from '../../../redux/ducks/modal'

import { IoteraForm } from '../../../lib/components/form';
import { SubViewHeaderStep } from '../../../lib/components/subHeader';
import { Button } from '@material-ui/core';
import { bindActionCreators } from 'redux';

import './style.scss'

import { upperFirstLetter } from '../../../lib/components/formatter';
import { setCallbackGlobal, unsetCallbackGlobal } from '../../../lib/components/callbackGlobal';

const INIT_TAGS = "INIT_TAGS";
const WKEY = "TAG_CAT_LIST";
const wBoundActions = buildWBoundActions(WKEY);
const wSelector = buildWSelector(WKEY)

function schema(properties) {
  return {
    title: "Pilih kategori yang akan dipakai untuk perangkat",
    type: "object",
    required: [],
    properties
  }
};

class Example extends Component {
  constructor(props) {
    super(props)
    this.state = {
      value: [],
      formData: {},
      values: '',
      loading: false,
      prevPath: ''
    }
    this.handleSubmit = this.handleSubmit.bind(this);
  }

  componentDidMount() {
    const _this = this;
    const _props = _this.props;
    const dit = domainIsTenant(_props);
    // callback global
    setCallbackGlobal(_props)
    _props.wInitRequestCall(
      {
        [INIT_TAGS]: {
          wparam: { ...dit, path: "/service/web/tag/category/get" },
          wcallback: {
            started: function (id) {
              // TODO Loading
            },
            finished: function (id, result) {
              // TODO Loading
              _this.setState({
                loading: false,
                tags: safeDeepGetWithType(result, ['body', 'categories'], [])
              })
            },
          }
        }
      }
    );
  }

  componentWillUnmount() {
    // callback global
    unsetCallbackGlobal(this.props)
  }

  componentWillReceiveProps(nextProps) {
    const _this = this
    const _props = _this.props
    if (nextProps.location !== _props.location) {
      _this.setState({ prevPath: _props.location })
    }
  }

  handleSubmit(event) {
    const _props = this.props
    let dataToSubmit = event.formData;
    let final = [];
    for (let key in dataToSubmit) {
      if (dataToSubmit.hasOwnProperty(key)) {
        let data = dataToSubmit[key];
        if (data === true) {
          final.push(key)
        }
      }
    }
    let action = setDeviceTagCategory(final);
    store.dispatch(action)
    if (final.length === 0) {
      _props.history.push('.' + S + 'sensors')
    } else {
      _props.history.push('.' + S + 'tag')
    }
  }

  goTo(link) {
    this.props.history.push(link)
  }

  goBack() {
    this.props.history.push('.' + S + 'info')
  };

  render() {
    const _this = this
    const _props = _this.props
    let items = safeDeepGet(_props, ['items']);
    let storeValue = store.getState();
    let dataToShow = storeValue;
    if (isEmpty(dataToShow)) {
      _this.goBack();
    } else {
      if ('device' in dataToShow) {
        if (isEmpty(dataToShow.device)) {
          _this.goBack();
        } else {
          dataToShow = { ...dataToShow.device };
        }
      } else {
        _this.goBack();
      }
    }
    let tagImport = safeDeepGetWithType(dataToShow, ['tag_cat'], []);
    for (let j = 0; j < tagImport.length; j++) {
      Object.assign(dataToShow, {
        [tagImport[j]]: true
      })
    }
    let propertiesSchema = {}
    let propertiesUiSchema = {}
    if (items.length > 0) {
      for (let i = 0; i < items.length; i++) {
        let item = items[i];
        let itemId = item.id;
        let itemName = upperFirstLetter(item.name);
        let itemCat = item.category;
        if (itemCat === 1) {
          let itemDef = item.definitions;
          if (itemDef.length === 0) {
            continue;
          }
        }
        Object.assign(propertiesSchema, {
          [itemId]: {
            title: itemName,
            'type': 'boolean'
          }
        })
        Object.assign(propertiesUiSchema, {
          [itemId]: {
            "ui:options": {
              label: false
            }
          }
        })
      }
    }
    return (
      <div className="view">
        <SubViewHeaderStep title='Tambah Perangkat' subTitle='Permohonan tambah perangkat baru' steps={['Kategori', 'Penanda', 'Aktivasi']} activeStep={1} />
        <div className="io-container mt-12">
          <IoteraForm
            schema={schema(propertiesSchema)}
            uiSchema={{}}
            formData={dataToShow}
            onSubmit={_this.handleSubmit}
          >
            <div className="button-right">
              <Button variant="outlined" size="large" style={{ minWidth: '0%' }} onClick={_props.history.goBack} >Kembali</Button>
              <Button variant="contained" size="large" color="primary" type="submit"
                style={{ marginLeft: 10, minWidth: '0%' }}>Berikutnya</Button>
            </div>
          </IoteraForm>
        </div>
      </div>
    );
  }
}

const mapStateToProps = function (state) {
  return {
    items: wSelector.getSoleInitMappedRPayload(state, ['categories'])
  }
}

const mapDispatchToProps = (dispatch) => ({
  ...wBoundActions(dispatch),
  ...bindActionCreators(notificationActions, dispatch),
  ...bindActionCreators(modalActions, dispatch),
});

export default connect(mapStateToProps, mapDispatchToProps)(withRouter(Example));